@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-3 mt-2">
      <select-field [selectFormControl]="getProjectJurisdictionSelect()" [options]="jurisdictionsOptions"
        label="Jurisdiction" />
    </div>
    <div class="col-sm-3 mt-2">
      <autocomplete-field
        [inputFormControl]="getChecklistGroupSelect()"
        [options]="checklistGroupOptions"
        label="Checklist Group"
        [valueType]="'number'"
        [displayKeyValue]="true"
        [minChars]="1"
        [placeholder]="'Checklist group'"
        (valueChange)="onChecklistGroupChange($event)"
      />
    </div>
    <div class="col-sm-1 mw-field mt-2">
      <input-field type="number" [inputFormControl]="getProjectRevisionInput()" label="Revision" placeholder="Revision" />
    </div>
    <div class="col-sm-4 mt-2">
      <input-field type="text" [inputFormControl]="getProjectDetailsInput()" label="Details"
        placeholder="Details" />
    </div>
  </div>
  <div class="text-center mt-4">
    <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
      Save
    </button>
  </div>
</form>